import { render, staticRenderFns } from "./shopDetail.vue?vue&type=template&id=18979a6a&scoped=true&"
import script from "./shopDetail.vue?vue&type=script&lang=js&"
export * from "./shopDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18979a6a",
  null
  
)

export default component.exports